import script from "./LastmileView.vue?vue&type=script&setup=true&lang=js"
export * from "./LastmileView.vue?vue&type=script&setup=true&lang=js"

import "./LastmileView.vue?vue&type=style&index=0&id=e784ddf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e784ddf4"]])

export default __exports__